import React from 'react';
import Loader from 'components/Loader';

const LoadingOverlay = () => (
	<div className="form-wrapper-blocker">
		<Loader />
	</div>
);

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/index.js